export default __webpack_public_path__ + "static/media/banner-simples-e.87046d26.svg";